import Swiper, { Navigation, Pagination } from 'swiper';
require('webpack-jquery-ui');
require('webpack-jquery-ui/css');

const banner_swiper = new Swiper('.banner_swiper', {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    observer: true,
    observeParents: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },

});

const product_swiper = new Swiper('.product_swiper_content', {
    modules: [Navigation],
    slidesPerView: 3,
    spaceBetween: 12,
    loop: true,
    observer: true,
    observeParents: true,
    navigation: {
        nextEl: ".product-swiper-next",
        prevEl: ".product-swiper-prev",
    },
    breakpoints: {
        1200: {
            slidesPerView: 5,
            spaceBetween: 14
        },
        768: {
            slidesPerView: 4,
            spaceBetween: 14
        }
    },
});

$('.section_product_item,.product_card_pic').on('mouseenter', function (event) {
    $(this).find('.hover_icon').css({ 'transform': 'translate(0%,-120%)'});
    $('.section_product_item,.product_card_pic').on('mouseleave', function (event) {
        $(this).find('.hover_icon').css({ 'transform': 'translate(0%,0%)'});
    });
});

$('.hover_icon.hover_icon_addFavorite').on('mouseenter', function (event) {
    $(this).find('i').removeClass('bi-bookmark-heart').addClass('bi-bookmark-heart-fill');
    $('.hover_icon_addFavorite').on('mouseleave', function (event) {
        $(this).find('i').removeClass('bi-bookmark-heart-fill').addClass('bi-bookmark-heart');
    });
});


$('.hover_icon.hover_icon_addCart').on('mouseenter', function (event) {
    $(this).find('i').removeClass('bi-cart-plus').addClass('bi-cart-plus-fill');
    $('.hover_icon_addCart').on('mouseleave', function (event) {
        $(this).find('i').removeClass('bi-cart-plus-fill').addClass('bi-cart-plus');
    });
});